var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6214,7.20032a2.51307,2.51307,0,0,0-1.76825-1.77967C18.29346,5,12.03931,5,12.03931,5S5.78509,5,4.2254,5.42065A2.513,2.513,0,0,0,2.45721,7.20032a26.36358,26.36358,0,0,0-.4179,4.84515,26.36358,26.36358,0,0,0,.4179,4.84515A2.513,2.513,0,0,0,4.2254,18.67029c1.55969.42065,7.81391.42065,7.81391.42065s6.25415,0,7.81384-.42065a2.51307,2.51307,0,0,0,1.76825-1.77967,26.363,26.363,0,0,0,.41791-4.84515A26.363,26.363,0,0,0,21.6214,7.20032ZM9.99383,15.01923V9.07178l5.2273,2.97381Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.a816481b2bfc2626a2848be4e4ad0552.svg";
export { ForwardRef as ReactComponent };